import Common from "../../../../Shared/Common";

const CompsAPI = {

    getPucko: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getPucko", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },
    getSpecies: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getSpecies", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },
    getSpecies: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getSpecies", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },
    getClubRecords: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getClubRecords", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },
    getPuckoAwards: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getPuckoAwards", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },
    getCompResult: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getCompResult", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    }
};
export default CompsAPI;

